module.exports = __webpack_public_path__ + "static/media/img_5.b929b297.png";